import Head from "next/head";
import { useTeamConfig } from "../components/TeamConfigProvider";

export function PageHeadContainer() {
  const teamConfig = useTeamConfig();

  return (
    <Head>
      <title>{teamConfig?.BROWSER_TITLE}</title>
      {process.env.NODE_ENV == "production" ? (
        <script
          nonce={process.env.NEXT_PUBLIC_CSP_NONCE}
          id="ss-crowdhandler"
          src="https://wait.crowdhandler.com/js/latest/main.js?id=5005898fce513ecad75524d94ddea75d844aef01f7604f4162fc367ac32dc4dc"
        ></script>
      ) : null}
    </Head>
  );
}
